// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PmiFromJSON, PmiToJSON, PmiPricesAllOfFromJSON, PmiPricesAllOfToJSON, } from './';
export function PmiPricesFromJSON(json) {
    return {
        ...PmiFromJSON(json),
        ...PmiPricesAllOfFromJSON(json),
    };
}
export function PmiPricesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        ...PmiToJSON(value),
        ...PmiPricesAllOfToJSON(value),
    };
}
